import React from 'react';

import { VpPluginSwitchSection } from './VpPluginSwitchSection';
import { VpPluginBorderInputs } from '../..';

export const VpPluginBorderSection = () => {
  return (
    <VpPluginSwitchSection name="showBorder" label="BORDER">
      <VpPluginBorderInputs />
    </VpPluginSwitchSection>
  );
};

export default VpPluginBorderSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginBorderSection.jsx